<template>
  <div class="site-alerts">
    <span class="d-none">{{lastCrawl.started_at}}</span>
    <b-alert :show="isPartialData" variant="info">
      <b-spinner small />
      Only partial data will be available while we finish processing your site
    </b-alert>
    <b-alert :show="isHighErrorRate" variant="warning">
      <strong>{{errorRate}}% of your pages returned an error during our last crawl.</strong> Typically this is due to a firewall issue. We recommend <b-link :to="{name: 'settings'}">Customizing our User Agent</b-link> and using that to whitelist our crawler.
    </b-alert>
    <b-alert :show="isHighDisallow" variant="info">
      Heads up: <strong>your robots.txt disallowed {{'page'|pluralize(robotsDisallow)}} during our last crawl.</strong> <b-link :to="{name: 'settings'}">Customizing our User Agent</b-link> allows you to create custom disallow rules.
    </b-alert>
    <b-alert :show="isDuplicateDomain" variant="warning">
      {{'page'|pluralize(domain_pages_aggregate.count)}} {{domain_pages_aggregate.count == 1 ? 'has' : 'have'}} already been crawled on other sites or accounts. If you believe some pages are missing, it is often because someone else has already activated the same domain with SiteSeer.
    </b-alert>
  </div>
</template>

<script>
import {get, isEmpty} from 'lodash'
import DOMAIN_PAGE_COUNT_QUERY from '@/graphql/DomainPageCountQuery.gql'

export default {
  name: 'SiteAlerts',
  props: ['site', 'isProcessing'],
  data() {
    return {
      domain_pages_aggregate: {}
    }
  },
  apollo: {
    domain_pages_aggregate: {
      query: DOMAIN_PAGE_COUNT_QUERY,
      variables() {
        return {
          site_id: Number(this.$route.params.site_id),
        }
      },
    },
  },
  computed: {
    lastCrawl() {
      return get(this.site, 'last_crawl[0].data', {})
    },
    isPartialData() {
      return !isEmpty(this.site) && isEmpty(this.site.last_processing)
    },
    errorRate() {
      const errors = this.lastCrawl.errors || 0
      const pages = this.lastCrawl.complete || 0
      return Math.round((errors / pages) * 100) || 0
    },
    isHighErrorRate() {
      return this.errorRate > 40
    },
    robotsDisallow() {
      return this.lastCrawl.disallow || 0
    },
    isHighDisallow() {
      return this.robotsDisallow > (this.lastCrawl.complete / 4)
    },
    isDuplicateDomain() {
      return this.site && this.domain_pages_aggregate.count > get(this.site, 'total_pages.aggregate.count')
    },
  },
}
</script>